import { useAtom } from 'jotai';
import { useState } from 'react';
import { DayPicker } from 'react-day-picker';

// Atoms
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';

// Types
import type { DateRange, DayClickEventHandler, DayMouseEventHandler } from 'react-day-picker';
import type { DatepickerRangeAtomImmer } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import type { DatepickerCalendarProps } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar';

// Components
import DatepickerBannerDataRetention from '@/components/composite/Datepicker/DatepickerBannerDataRetention';

type DatepickerRangeProps = DatepickerCalendarProps;

export function DatepickerRange({ displayDataRetentionBanner }: DatepickerRangeProps) {
    const [datepicker, setDatepicker] = useAtom(datepickerAtom as DatepickerRangeAtomImmer);

    const fromDate = datepicker.settings?.minDate ? new Date(datepicker.settings.minDate) : null;
    const toDate = datepicker.settings?.maxDate ? new Date(datepicker.settings.maxDate) : null;

    const [hoverSelectedDateRage, setHoverSelectedDateRage] = useState<{
        dateRange: DateRange;
        selectedDate: Date;
    }>(null);

    const handleDayClick: DayClickEventHandler = (day) => {
        if (hoverSelectedDateRage?.dateRange.to) {
            setHoverSelectedDateRage(null);
            return setDatepicker((draft) => {
                draft.date = hoverSelectedDateRage.dateRange;
                draft.period = 'custom';
            });
        }

        setHoverSelectedDateRage({ dateRange: { from: day }, selectedDate: day });
    };

    const handleDayHover: DayMouseEventHandler = (day) => {
        if (!hoverSelectedDateRage?.selectedDate) return;

        if (hoverSelectedDateRage.selectedDate < day) {
            return setHoverSelectedDateRage((prevState) => ({
                ...prevState,
                dateRange: { from: hoverSelectedDateRage.selectedDate, to: day }
            }));
        }

        return setHoverSelectedDateRage((prevState) => ({
            ...prevState,
            dateRange: { from: day, to: hoverSelectedDateRage.selectedDate }
        }));
    };

    return (
        <div className="px-2 py-5">
            <DayPicker
                mode="range"
                showOutsideDays
                fromDate={fromDate}
                toDate={toDate}
                selected={hoverSelectedDateRage?.dateRange ?? datepicker.date}
                onDayClick={handleDayClick}
                onDayMouseEnter={handleDayHover}
                {...datepicker.dayPickerOptions}
            />
            {displayDataRetentionBanner ? (
                <div className="mt-3 px-3">
                    <DatepickerBannerDataRetention />
                </div>
            ) : null}
        </div>
    );
}
